module.exports = {
  langs: ['sv', 'en'],
  defaultLang: 'sv',
  shortenUrlLangs: false,
  useDefaultLangInUrl: false,
};
